<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ headerTitle }}</h1>
      </div>
    </div>

    <p-selectbutton [formControl]="selectedSection" [options]="section" optionLabel="label" optionValue="value" unselectable="true" />

    <div class="grid-1">
      <!-- Approvals Tab -->
      @if (selectedSection.value === 0) {
        <div class="cs-page-list-grid">
          <!-- Filters Panel -->
          @if (filterConfig() && showFilters()) {
            <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
          }

          <!-- Data Table Panel -->
          <p-panel [header]="'Surplus_Pending_Approvals' | translateWF: 'Pending Approvals'">
            <ng-template pTemplate="icons">
              <p-button
                [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                (click)="showFilters.set(!showFilters())"
                variant="outlined"
                size="small"
              />
            </ng-template>
            <p-card data-variant="compact">
              <p-table
                [value]="allPendingTransactions"
                class="table w-full"
                [loading]="isLoading > 0"
                [paginator]="true"
                [rows]="pageSize"
                [totalRecords]="totalRecords"
                [lazy]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions"
                [rowsPerPageOptions]="[10, 25, 50, 100]"
              >
                <ng-template #header>
                  <tr class="dark__header">
                    <th class="text-center">{{ 'Status' | translateWF: 'Status' }}</th>
                    <th class="text-center">{{ 'Knitting Order' | translateWF: 'Knitting Order' }}</th>
                    <th class="text-center">{{ 'Lot Item(s)' | translateWF: 'Lot Item(s)' }}</th>
                    <th class="text-center">{{ 'Quantity' | translateWF: 'Quantity' }}</th>
                    <th class="text-center">{{ 'Created Date' | translateWF: 'Created Date' }}</th>
                    <th class="text-center">{{ 'Actions' | translateWF: 'Actions' }}</th>
                  </tr>
                </ng-template>
                @if (allPendingTransactions.length > 0) {
                  <ng-template #body let-item>
                    <tr>
                      <td class="text-center">
                        <p-tag [value]="getStatusLabel(item.transaction.status)" [severity]="getStatusBadgeSeverity(item.transaction.status)"></p-tag>
                      </td>
                      <td class="text-center">
                        <b>{{ item.knittingOrder?.knittingOrderNumber || 'N/A' }}</b>
                      </td>
                      <td class="text-center">
                        @for (line of item.transaction.lines; track line.lotItemNumber) {
                          <div>{{ line.lotItemNumber }}</div>
                        }
                      </td>
                      <td class="text-center">
                        @for (line of item.transaction.lines; track line.lotItemNumber) {
                          <div>{{ line.quantity | number: '1.2-2' }} lbs</div>
                        }
                      </td>
                      <td class="text-center">{{ item.transaction.createdDate | date: 'short' }}</td>
                      <td class="text-center">
                        <div class="row-sm justify-center">
                          @if (canDownloadReport(item.transaction.status)) {
                            <p-button
                              label="{{ 'Download Report' | translateWF: 'Download Report' }}"
                              icon="pi pi-download"
                              (onClick)="onDownloadReport(item.transaction.id)"
                              size="small"
                              [outlined]="true"
                            ></p-button>
                          }
                          @if (canReceiveReturnSurplus() && item.transaction.status === 1) {
                            <p-button
                              label="{{ 'Approve' | translateWF: 'Approve' }}"
                              icon="pi pi-check"
                              (onClick)="onApproveTransaction(item.transaction.id, item.knittingOrder?.knittingOrderNumber || 'N/A')"
                              size="small"
                            ></p-button>
                          }
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                } @else {
                  <ng-template #emptymessage>
                    <tr>
                      <td colspan="6" class="text-center">
                        {{ 'No return surplus transactions found' | translateWF: 'No return surplus transactions found' }}
                      </td>
                    </tr>
                  </ng-template>
                }
              </p-table>
            </p-card>
          </p-panel>
        </div>
      }

      <!-- Surplus & Transfer Tabs -->
      @if (selectedSection.value === 1 || selectedSection.value === 2) {
        @if (selectedSection.value === 2) {
          <p-message severity="info" styleClass="w-full">
            <span>
              <strong>{{ 'Transfer_Disclaimer_Title' | translateWF: 'Important' }}:</strong>
              {{
                'Transfer_Disclaimer_Body'
                  | translateWF
                    : 'Only surplus pounds from closed Knitting Orders can be transferred. Remember that this reassignment must
          be validated with a physical yarn weighing.'
              }}
            </span>
          </p-message>
        }
        <p-card>
          <div class="grid grid-col-1 md: grid-cols-2 mb-4">
            <div class="form-box">
              <label class="mb-2" for="knittingOrderSearch">{{ 'Yarn_Requisitions_Details_Knitting_Order' | translateWF: 'Knitting Order' }}</label>
              <p-autocomplete
                [inputId]="'knittingOrderSearch'"
                fluid
                #sourceKnittingOrderSearchRef="cslServerSearch"
                [cslServerSearch]="fetchSourceKnittingOrders"
                [suggestions]="sourceKnittingOrderSearchRef.results()"
                optionLabel="knittingOrderNumber"
                [dropdown]="true"
                [formControl]="knittingOrderSearch"
                class="w-full"
                styleClass="w-full"
                (onSelect)="onKnittingOrderSelected($event)"
                [showClear]="true"
                (onClear)="onKnittingOrderSelected()"
              ></p-autocomplete>
            </div>
          </div>
        </p-card>
        <p-panel [header]="'Lot_Items_With_Surplus' | translateWF: 'Lot Items With Surplus'">
          <p-card data-variant="compact">
            <p-table [value]="availableLotItems" class="table w-full">
              <ng-template #header>
                <tr class="dark__header">
                  <th class="text-center">{{ 'Items_Inventory_Lot_Item_Number' | translateWF: 'Lot Item Number' }}</th>
                  <th class="text-center">
                    {{ 'Items_Inventory_Item_Description' | translateWF: 'Item Description' }}
                  </th>
                  <th class="text-center">
                    {{ 'Common_Manufacturer' | translateWF: 'Manufacturer' }}
                  </th>
                  <th class="text-center">
                    {{ 'Common_Manufacturer_Lot_Number' | translateWF: 'Manufacturer Lot Number' }}
                  </th>
                  <th>{{ 'Current_Net_Weight' | translateWF: 'Current Net Weight' }}</th>
                </tr>
              </ng-template>
              @if (availableLotItems.length > 0) {
                <ng-template #body let-lotItem let-rowIndex="rowIndex">
                  @let typedLotItem = asLotItem(lotItem);
                  <tr>
                    <td>
                      <b>{{ typedLotItem.number }}</b>
                    </td>
                    <td>({{ typedLotItem.item?.itemCode }}){{ typedLotItem?.item?.itemDescription?.en }}</td>
                    <td>
                      {{ typedLotItem.manufacturer?.name }}
                    </td>

                    <td>
                      {{ typedLotItem.providerLotId }}
                    </td>
                    <td>
                      <p-inputgroup>
                        <p-inputNumber [ngModel]="typedLotItem.originalNetQuantity" [maxFractionDigits]="2" [disabled]="true" />
                        <p-inputgroup-addon>lbs</p-inputgroup-addon>
                      </p-inputgroup>
                    </td>
                  </tr>
                </ng-template>
              }
            </p-table>
          </p-card>
        </p-panel>
        <p-panel [header]="'Lots_With_Surplus' | translateWF: 'Lot With Surplus'">
          <ng-template pTemplate="icons">
            <p-button [label]="'Add_New_Lot' | translateWF: 'Add New Lot'" variant="outlined" icon="pi pi-plus" (onClick)="isAdding = true" />
          </ng-template>

          <p-panel *ngIf="isAdding" class="my-[1rem]" [formGroup]="newLotItemForm" [header]="'New_Lot_Item' | translateWF: 'New Lot Item'">
            <p-card>
              <div class="grid-12">
                <!-- Item Description Select -->
                <div class="form-box span-8">
                  <label>{{ 'Items_Inventory_Item_Description' | translateWF: 'Item Description' }}</label>
                  <p-select
                    [options]="groupedItems"
                    optionLabel="localizedDescription"
                    formControlName="groupedItem"
                    placeholder="Select Item"
                    [showClear]="true"
                    [filter]="true"
                    filterBy="localizedDescription,manufacturerName,providerLotId"
                    class="w-full"
                    styleClass="w-full"
                    appendTo="body"
                  >
                    <ng-template let-option #selectedItem>
                      <div class="row-sm-start-center min-w-0">
                        <span class="font-medium truncate">{{ option.localizedDescription }}</span>
                        @if (option.manufacturerName) {
                          <p-tag [value]="option.manufacturerName" severity="info" styleClass="text-xs" />
                        }
                        @if (option.providerLotId) {
                          <span class="text-xs text-gray-500 truncate">{{ 'Lot' | translateWF: 'Lot' }} {{ option.providerLotId }}</span>
                        }
                      </div>
                    </ng-template>
                    <ng-template let-option #item>
                      <div class="row-between-center gap-3 w-full py-1">
                        <div class="col min-w-0 flex-1">
                          <span class="font-medium truncate">{{ option.localizedDescription }}</span>
                          <div class="row-sm-start-center mt-1">
                            @if (option.manufacturerName) {
                              <p-tag [value]="option.manufacturerName" severity="info" styleClass="text-xs" />
                            } @else {
                              <span class="text-xs text-gray-400 italic">{{
                                'No_Manufacturer'
                                  | translateWF
                                    : 'No
                            manufacturer'
                              }}</span>
                            }
                            @if (option.providerLotId) {
                              <span class="text-xs text-gray-500"> <i class="pi pi-tag text-[10px] mr-1"></i>{{ option.providerLotId }} </span>
                            }
                          </div>
                        </div>
                        <div class="col items-end flex-shrink-0">
                          <span class="text-sm font-semibold">{{ option.totalNetQuantity | number: '1.2-2' }}</span>
                          <span class="text-[10px] text-gray-500 uppercase tracking-wide">lbs</span>
                        </div>
                      </div>
                    </ng-template>
                  </p-select>
                </div>

                <!-- Excess Weight Input (Disabled with pipe formatting) -->
                <div class="form-box span-4">
                  <label>{{ 'Excess_Weight' | translateWF: 'Excess Weight (Lbs)' }}</label>
                  <p-inputgroup>
                    <p-inputNumber [formControl]="excessWeight" [maxFractionDigits]="2" [disabled]="true" />
                    <p-inputgroup-addon>lbs</p-inputgroup-addon>
                  </p-inputgroup>
                </div>

                <div class="row-start-center" *ngIf="selectedSection.value === 1">
                  <p-button icon="pi pi-arrow-right" variant="text" (onClick)="onClickOpenModal()" [disabled]="newLotItemForm.invalid" />
                </div>
              </div>
              <div class="grid-3" *ngIf="selectedSection.value === 2">
                <div class="form-box mr-4">
                  <label>Target Knitting Order</label>
                  <p-autoComplete
                    [inputId]="'targetKnittingOrderSearch'"
                    fluid
                    #targetKnittingOrderSearchRef="cslServerSearch"
                    [cslServerSearch]="fetchTargetKnittingOrders"
                    [suggestions]="targetKnittingOrderSearchRef.results()"
                    optionLabel="knittingOrderNumber"
                    [dropdown]="true"
                    [formControl]="targetKnittingOrderSearch"
                    class="w-full"
                    styleClass="w-full"
                    (onSelect)="onTargetKnittingOrderSelected($event)"
                    [showClear]="true"
                    (onClear)="onTargetKnittingOrderSelected()"
                  ></p-autoComplete>
                </div>
              </div>

              <!-- Target Knitting Order Entries Table (Transfer Mode) -->
              @if (selectedSection.value === 2 && selectedTargetKnittingOrder() && newLotItemForm.get('groupedItem')?.value) {
                <div class="span-3 mt-4">
                  <label class="mb-2">{{ 'Target_Entries' | translateWF: 'Target Entries' }}</label>

                  <!-- Warning: No matching item code -->
                  @if (!hasAnyMatchingItemCode()) {
                    <p-message severity="warn" styleClass="mb-2 w-full">
                      {{
                        'No_Matching_Item_Code'
                          | translateWF
                            : 'There are no entries that match the selected item code. This
                item cannot be transferred.'
                      }}
                    </p-message>
                  }

                  <!-- Warning: No matching manufacturer and lot -->
                  @if (hasAnyMatchingItemCode() && !hasMatchingManufacturerAndLot()) {
                    <p-message severity="warn" styleClass="mb-2 w-full">
                      {{
                        'No_Matching_Manufacturer_Lot'
                          | translateWF
                            : 'There are no entries with the same manufacturer and manufacturer lot number. This item
                cannot be transferred.'
                      }}
                    </p-message>
                  }

                  <p-table [value]="selectedTargetKnittingOrder()!.fabricQuantityDetails" class="table w-full mt-2" dataKey="variantCode">
                    <ng-template #header>
                      <tr class="dark__header">
                        <th class="text-center">{{ 'Fabric_Code' | translateWF: 'Fabric Code' }}</th>
                        <th class="text-center">{{ 'Variant_Code' | translateWF: 'Variant Code' }}</th>
                        <th class="text-center">{{ 'Item_Code' | translateWF: 'Item Code' }}</th>
                        <th class="text-center">{{ 'Manufacturer' | translateWF: 'Manufacturer' }}</th>
                        <th class="text-center">{{ 'Manufacturer_Lot' | translateWF: 'Manufacturer Lot' }}</th>
                        <th class="text-center">{{ 'Actions' | translateWF: 'Actions' }}</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-entry>
                      <tr
                        [class.opacity-40]="isEntryDisabledForTransfer(entry)"
                        [class.cursor-not-allowed]="isEntryDisabledForTransfer(entry)"
                        [class.bg-gray-50]="isEntryDisabledForTransfer(entry)"
                      >
                        <td>
                          <b>{{ entry.fabricCode }}</b>
                        </td>
                        <td>{{ entry.variantCode }}</td>
                        <td>
                          <div class="col-sm">
                            @for (itemMaster of getEntryItemCodes(entry); track $index) {
                              @if (itemMaster) {
                                <span class="text-sm">
                                  <b>({{ itemMaster.itemCode }})</b> {{ itemMaster.itemDescription.en }}
                                </span>
                              } @else {
                                <span class="text-sm text-gray-400">N/A</span>
                              }
                            }
                          </div>
                        </td>
                        <td>
                          <div class="col-sm">
                            @for (yarnInfo of entry.yarnAndProviderInfos; track $index) {
                              <span class="text-sm">{{ yarnInfo.provider?.name || 'N/A' }}</span>
                            }
                          </div>
                        </td>
                        <td>
                          <div class="col-sm">
                            @for (yarnInfo of entry.yarnAndProviderInfos; track $index) {
                              <span class="text-sm">{{ yarnInfo.providerLotNumber || 'N/A' }}</span>
                            }
                          </div>
                        </td>
                        <td>
                          <p-button
                            [label]="'Transfer' | translateWF: 'Transfer'"
                            icon="pi pi-arrow-right"
                            size="small"
                            [disabled]="isEntryDisabledForTransfer(entry)"
                            (onClick)="onTransferToEntry(entry)"
                          />
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              }
            </p-card>
          </p-panel>
        </p-panel>
        <p-panel [header]="'Return_Lot_items' | translateWF: 'Returned Lot Items'">
          <p-card data-variant="compact">
            <p-table [value]="lotItemsWithSurplus" class="table w-full">
              <ng-template #header>
                <tr class="dark__header">
                  <th class="text-center">{{ 'Status' | translateWF: 'Status' }}</th>
                  <th class="text-center">{{ 'Items_Inventory_Lot_Item_Number' | translateWF: 'Lot Item Number' }}</th>
                  <th class="text-center">
                    {{ 'Items_Inventory_Item_Description' | translateWF: 'Item Description' }}
                  </th>
                  <th class="text-center">
                    {{ 'Notes' | translateWF: 'Notes' }}
                  </th>
                  <th class="text-center">
                    {{ 'Common_Manufacturer' | translateWF: 'Manufacturer' }}
                  </th>

                  <th class="text-center">
                    {{ 'Common_Manufacturer_Lot_Number' | translateWF: 'Manufacturer Lot Number' }}
                  </th>
                  <th>{{ 'Original_Net_Weight' | translateWF: 'Original Net Weight' }}</th>
                  <th>{{ 'Current_Net_Weight' | translateWF: 'Current Net Weight' }}</th>
                  @if (canReceiveReturnSurplus()) {
                    <th class="text-center">{{ 'Actions' | translateWF: 'Actions' }}</th>
                  }
                </tr>
              </ng-template>
              @if (lotItemsWithSurplus.length > 0) {
                <ng-template #body let-lotItem let-rowIndex="rowIndex">
                  @let typedLotItem = asLotItem(lotItem);
                  @let status = getLotItemStatus(typedLotItem);
                  <tr>
                    <td class="text-center">
                      <p-tag [value]="getStatusLabel(status)" [severity]="getStatusBadgeSeverity(status)"></p-tag>
                    </td>
                    <td>
                      <b>{{ typedLotItem.number }}</b>
                    </td>
                    <td>({{ typedLotItem?.item?.itemCode }}){{ typedLotItem?.item?.itemDescription?.en }}</td>

                    <td>
                      {{ getNotes(typedLotItem) }}
                    </td>
                    <td>
                      {{ typedLotItem.manufacturer?.name }}
                    </td>
                    <td>
                      {{ typedLotItem.providerLotId }}
                    </td>
                    <td>
                      <p-inputgroup>
                        <p-inputNumber [ngModel]="typedLotItem.originalNetQuantity" [maxFractionDigits]="2" [disabled]="true" />
                        <p-inputgroup-addon>lbs</p-inputgroup-addon>
                      </p-inputgroup>
                    </td>
                    <td>
                      <p-inputgroup>
                        <p-inputNumber [ngModel]="typedLotItem.netQuantity" [maxFractionDigits]="2" [disabled]="true" />
                        <p-inputgroup-addon>lbs</p-inputgroup-addon>
                      </p-inputgroup>
                    </td>
                    @if (canReceiveReturnSurplus()) {
                      <td class="text-center">
                        @if (isPendingApproval(typedLotItem)) {
                          <p-button
                            [label]="'Approve' | translateWF: 'Approve'"
                            icon="pi pi-check"
                            size="small"
                            severity="success"
                            (onClick)="onReceiveReturnSurplus(typedLotItem)"
                          />
                        }
                      </td>
                    }
                  </tr>
                </ng-template>
              }
            </p-table>
          </p-card>
        </p-panel>
      }
    </div>
  </div>
</main>
